<template>
  <div id="modal-header" class="row no-gutters">
    <div class="col pl-4 title-container" style="padding-top: 2px">
      <p class="modal-title" :style="titleStyle" :lang="narratorLang" tabindex="-1" :aria-label="$t(titleText)">
        {{ $t(titleText) }}
      </p>
    </div>
    <div class="col-auto pr-4 close-container" style="min-height: 24px; padding-top: 2px">
      <div v-if="hasExit" ref="icon-close" class="icon-close text-right" @click="closeModal" tabindex="0" @keyup.enter="closeModal"
        :lang="narratorLang" :aria-label="$t('app.settings.pager.closeBtn.ariaLabel')"
      >
        <svg
          id="baseline-close-24px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            id="Path_8625"
            data-name="Path 8625"
            class="cls-1"
            d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
          />
          <path
            id="Path_8626"
            data-name="Path 8626"
            class="cls-2"
            d="M0,0H24V24H0Z"
          />
        </svg>
      </div>
    </div>
    <div class="col-12 pt-4 line-col" v-if="hasSeparator">
      <hr class="line" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ModalHeader',
  props: {
    titleText: {
      type: String,
      required: true,
    },
    titleStyle: {
      type: [Object, Array],
      required: false,
      default: () => ({
        fontFamily: 'Roboto',
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#616161',
      }),
    },
    hasExit: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasSeparator: {
      type: Boolean,
      required: false,
      default: true,
    },
    closedEvent: {
      type: Function,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      narratorLang: 'settings/getNarratorLanguage',
    }),
  },
  mounted() {
    if (document.getElementsByClassName('user-is-tabbing').length !== 0) {
      this.focus();
    }
    document.getElementsByClassName('modal-title')[0].focus();
  },
  methods: {
    focus() {
      setTimeout(() => {
        if (this.$refs['icon-close']) this.$refs['icon-close'].focus();
      }, 100);
    },
    closeModal() {
      if (this.closedEvent) {
        this.closedEvent();
      } else {
        this.$eventBus.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#modal-header {
  .line {
    height: 1px;
    background-color: var(--lightGrey);
    box-sizing: border-box;
    margin: 0;
    border-style: initial;
  }
  .modal-title {
    font-family: Roboto;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    color: var(--terraGrey);
    word-break: break-word;
  }
  .icon-close {
    cursor: pointer;
    width: 24px;
    height: 24px;
    /deep/ .cls-2 {
      fill: transparent;
    }
    /deep/ .cls-1 {
      fill: var(--terraGrey);
    }
  }
}
</style>
